import React from 'react';
import { Col, Row, Toast, ToastContainer } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const NotificationToast = ({ message, variant, show, onClose }) => {
    const getIcon = () => {
        switch (variant) {
            case 'success':
                return <FontAwesomeIcon icon={faCheckCircle} size='2xl' />;
            case 'danger':
                return <FontAwesomeIcon icon={faTimesCircle} size='2xl' />;
            case 'info':
                return <FontAwesomeIcon icon={faInfoCircle} size='2xl' />;
            case 'warning':
                return <FontAwesomeIcon icon={faExclamationTriangle} size='2xl' />;
            default:
                return null;
        }
    };

    return (
        <ToastContainer position="top-center" className="p-3 mt-5" style={{ position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}>
            <Toast
                onClose={onClose}
                show={show}
                delay={4000}
                autohide
                style={{ backgroundColor: getBackgroundColor(variant), color: 'white' }}
            >
                <Toast.Body>
                    <Row>
                        <Col xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                            {getIcon()}
                        </Col>
                        <Col xs={10}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <strong className="ms-0 me-auto">{getTitle(variant)}</strong>
                                <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={onClose}></button>
                            </div>
                            <div>

                                {' '}{message}
                            </div>
                        </Col>
                    </Row>
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

const getTitle = (variant) => {
    switch (variant) {
        case 'success':
            return 'Επιτυχής';
        case 'danger':
            return 'Κίνδυνος';
        case 'info':
            return 'Πληροφορίες';
        case 'warning':
            return 'Προειδοποίηση';
        default:
            return 'Ειδοποίηση';
    }
};

const getBackgroundColor = (variant) => {
    switch (variant) {
        case 'success':
            return '#28a745'; // Πράσινο για επιτυχία
        case 'danger':
            return '#dc3545'; // Κόκκινο για αποτυχία
        case 'info':
            return '#17a2b8'; // Μπλε για πληροφορία
        case 'warning':
            return '#ffc107'; // Πορτοκαλί για προειδοποίηση
        default:
            return '#6c757d'; // Γκρι για default
    }
};

NotificationToast.propTypes = {
    message: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['success', 'danger', 'info', 'warning']).isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default NotificationToast;
